export const desktopUpdate = {
  data() {
    return {
      showUpdateDialog: false
    }
  },
  methods: {
    showUpdate() {
      this.showUpdateDialog = true
    }
  }
}
